import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HousesRouterComponent } from './houses/houses-router.component';
import { HousesComponent } from './houses/houses.component';
import { PartnersComponent } from './partners/partners.component';
import { HouseDetailsComponent } from './houses/house-details.component';
import { ContactComponent } from './contact/contact.component';
import { ProjectService } from './common-theme/api/project.service';
import { PropertyService } from './common-theme/api/property.service';
import { SimpleLimitsService } from './common-theme/api/simple-limits.service';
import { ApartmentTypeService } from './common-theme/api/apartment-type.service';
import { ReasonService } from './common-theme/api/reason.service';
import { PartnerService } from './common-theme/api/partner.service';
import { BuildingFloorService } from './common-theme/api/building-floor.service';
import { BuildingsComponent } from './buildings/buildings.component';
import { BuildingsRouterComponent } from './buildings/buildings-router.component';
import { FloorsComponent } from './floors/floors.component';
import { GalleryPageComponent } from './gallery-page/gallery-page.component';
import { ApartmentTypeDetailsComponent } from './houses/apartment-type-details.component';
import { LocalisationComponent } from './localisation/localisation.component';
import { ParkingComponent } from './parking/parking.component';

import { AboutUsComponent } from './about-us/about-us.component';
import { FacilitiesComponent } from './about-us/facilities.component';
import { ProjectComponent } from './about-us/project.component';
import { HistoryComponent } from './about-us/history.component';
import { FinishesComponent } from './about-us/finishes.component';

const app_routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: {
      projects: ProjectService,
      properties: PropertyService,
      simple_limits: SimpleLimitsService,
      reasons: ReasonService
    }
  },
  {
    path: 'despre-noi',
    component: AboutUsComponent,
    children: [
      {
        path: 'facilitati',
        component: FacilitiesComponent
      },
      {
        path: 'istorie',
        component: HistoryComponent
      },
      {
        path: 'proiect',
        component: ProjectComponent
      },
      {
        path: 'finisaje',
        component: FinishesComponent
      }
    ]
  },
  {
    path: 'localizare',
    component: LocalisationComponent
  },
  {
    path: 'parteneri',
    component: PartnersComponent,
    resolve: { partners: PartnerService }
  },
  {
    path: 'parcari',
    component: ParkingComponent
  },
  {
    path: 'galerie',
    component: GalleryPageComponent
  },
  {
    path: 'tip-apartament/:friendly_id',
    component: ApartmentTypeDetailsComponent,
    resolve: {
      apartment_type: ApartmentTypeService
    }
  },
  {
    path: 'apartamente/:friendly_id',
    component: HouseDetailsComponent,
    resolve: { property: PropertyService }
  },
  {
    path: 'apartamente-noi-rahova-salaj-sector5-bucuresti',
    component: HousesRouterComponent,
    data: {
      property_type: 'apartamente',
      property_search: {
        sort: 'rank'
      },
      page_type: 'apartamente-noi-rahova-salaj-sector5-bucuresti'
    },
    resolve: {
      simple_limits: SimpleLimitsService
    },
    children: [
      {
        path: '',
        component: HousesComponent
      }
    ]
  },
  {
    path: 'cartierul-nou-salaj',
    component: HousesRouterComponent,
    data: {
      property_type: 'apartamente',
      property_search: {
        sort: 'rank'
      },
      page_type: 'cartierul-nou-salaj'
    },
    resolve: {
      simple_limits: SimpleLimitsService
    },
    children: [
      {
        path: '',
        component: HousesComponent
      }
    ]
  },
  {
    path: 'garsoniere-de-vanzare-rahova-sector-5',
    component: HousesRouterComponent,
    data: {
      property_type: 'apartamente',
      property_search: {
        sort: 'rank',
        room_count: 1
      },
      page_type: 'garsoniere-de-vanzare-rahova-sector-5'
    },
    resolve: {
      simple_limits: SimpleLimitsService
    },
    children: [
      {
        path: '',
        component: HousesComponent
      }
    ]
  },
  {
    path: 'apartamente-2-camere-de-vanzare-rahova-sector-5',
    component: HousesRouterComponent,
    data: {
      property_type: 'apartamente',
      property_search: {
        sort: 'rank',
        room_count: 2
      },
      page_type: 'apartamente-2-camere-de-vanzare-rahova-sector-5'
    },
    resolve: {
      simple_limits: SimpleLimitsService
    },
    children: [
      {
        path: '',
        component: HousesComponent
      }
    ]
  },
  {
    path: 'apartamente-3-camere-de-vanzare-rahova-sector-5',
    component: HousesRouterComponent,
    data: {
      property_type: 'apartamente',
      property_search: {
        sort: 'rank',
        room_count: 3
      },
      page_type: 'apartamente-3-camere-de-vanzare-rahova-sector-5'
    },
    resolve: {
      simple_limits: SimpleLimitsService
    },
    children: [
      {
        path: '',
        component: HousesComponent
      }
    ]
  },
  {
    path: 'locuinte',
    component: HousesRouterComponent,
    data: {
      property_type: 'apartamente',
      property_search: {
        sort: 'rank'
      }
    },
    resolve: {
      simple_limits: SimpleLimitsService
    },
    children: [
      {
        path: '',
        component: HousesComponent
      },
      {
        path: ':friendly_id',
        component: HouseDetailsComponent,
        resolve: { property: PropertyService }
      }
    ]
  },
  {
    path: 'contacteaza-ne',
    component: ContactComponent
  },
  {
    path: 'bloc/:project_id',
    component: BuildingsRouterComponent,
    children: [
      {
        path: '',
        component: BuildingsComponent,
        resolve: {
          project: ProjectService,
          building_floors: BuildingFloorService
        }
      },
      {
        path: ':building_floor_id',
        component: FloorsComponent,
        resolve: {
          building_floor: BuildingFloorService
        }
      }
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];
export const app_routing = RouterModule.forRoot(app_routes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts